import React, { forwardRef, useState } from "react";
import {
  CreditCardProps,
  RefsCreditCard,
} from "./types/credit-card-fields.types";
import { CardNumber } from "./credit-card-fields-components/card-number";
import { CvvField } from "./credit-card-fields-components/cvv";
import { ExpirationDateField } from "./credit-card-fields-components/expiration-date";
import { CreditCardName } from "./credit-card-fields-components/name";
import { DefaultPayment } from "./credit-card-fields-components/default-payment";

export interface CardFieldSetWithForwardRef
  extends React.ForwardRefExoticComponent<
    CreditCardProps & React.RefAttributes<() => RefsCreditCard>
  > {}

export const CreditCardFieldset = forwardRef<
  () => RefsCreditCard,
  CreditCardProps
>(
  (
    { label, creditCard, expirationDate, cvvField, nameOnCard, defaultPayment },
    ref
  ): React.ReactElement => {
    const [cvvLength, setCvvLength] = useState<number>(3);
    const {
      cardNumberRef,
      expirationDateFieldRef,
      cvvFieldRef,
      nameOnCardRef,
      defaultPaymentRef,
    } = (ref as any)?.() || {};
    return (
      <>
        {label && <h5>{label}</h5>}
        <div className="spark-payment--card-set">
          <CardNumber
            {...creditCard}
            setCvvLength={setCvvLength}
            ref={cardNumberRef}
          />
          <div className="row spark-mar-b-1">
            <div className="col-xs-12 col-md-7 col-lg-8 spark-mar-b-1--lte-sm">
              <ExpirationDateField
                {...expirationDate}
                ref={expirationDateFieldRef}
              />
            </div>
            <div className="col-xs-12 col-md-5 col-lg-4 spark-pad-l-0--gte-md">
              <CvvField {...cvvField} cvvLength={cvvLength} ref={cvvFieldRef} />
            </div>
          </div>
        </div>
        {nameOnCard && <CreditCardName {...nameOnCard} ref={nameOnCardRef} />}
        {defaultPayment && (
          <DefaultPayment {...defaultPayment} ref={defaultPaymentRef} />
        )}
      </>
    );
  }
) as CardFieldSetWithForwardRef;

CreditCardFieldset.displayName = "CreditCardFieldset";
